import { HOUSEHOLD_AT_CONSTANTS, HOUSEHOLD_STEPS } from '@flows/configs/householdAt/constants'
import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_HouseholdV1GetsafeAt } from '@flows/insurance/schemas'

const household_at_deductible_amount = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('deductible_amount')]:
        BaseSchema_HouseholdV1GetsafeAt.shape.deductible_amount,
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_householdAt:steps.deductible_amount.title',
        },
      },
      {
        type: 'choice',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('deductible_amount'),
        options: HOUSEHOLD_AT_CONSTANTS.deductibleOptions.map((option) => {
          return {
            value: Number(option),
            label: {
              type: 'nonTranslatableText',
              text: params.clientHelpers.formatter.formatCurrency(option),
            },
          }
        }),
      },
      {
        type: 'infoBox',
        contentSpaceSize: 'none',
        contentConfiguration: [
          {
            type: 'title',
            text: {
              type: 'translatableText',
              translationKey: 'sharedFlows_householdAt:steps.deductible_amount.infoTitle',
            },
          },
          {
            type: 'text',
            text: {
              type: 'translatableText',
              translationKey: 'sharedFlows_householdAt:steps.deductible_amount.infoSubtitle',
            },
          },
          {
            type: 'spacer',
            size: 'small',
          },
          {
            type: 'text',
            text: {
              type: 'translatableText',
              translationKey: 'sharedFlows_householdAt:steps.deductible_amount.infoSubtitle2',
            },
          },
        ],
      },
    ],
    subFlow: params.subFlow,
    nextStep: HOUSEHOLD_STEPS.household_at_born_on,
  }) as const satisfies AnyStepConfiguration

export default household_at_deductible_amount
